import React, { useState, useEffect } from "react";
import { Card, CardBody, Container } from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Grid from '@mui/material/Grid';
import { PaginationComponent } from "../../Components/casp/common/PaginationComponent";
import VisitorLogo from '../../assets/images/KVP Logo V3.png_1733200369161.svg';
import VisitorKacstLogo from '../../assets/images/Powered by KACST1.png (1)_1733200369161 (1).svg';
import { getVisitorProjectsSectorWise } from "../../api/casp/visitor";
import { toast } from "react-toastify";
import { getUrl } from "../../helpers/file_helper";
import projectNoLog from '../../assets/images/no-data.png'
import { Tooltip } from "@mui/material";
import VisitorSmallLogo from '../../assets/images/MicrosoftTeams-image (116).png';
import VisitorSmallKacstLogo from '../../assets/images/visitor-small.svg'
import { fetchSector } from "../../constants/PriorityIcon";

const EnergyIndustry = () => {
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState()
  const [isLogoMobile, setIsLogoMobile] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [paginationObject, setPaginationObject] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [projectData, setProjectData] = useState()
  const params = useParams()

  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(false);
  const toggleHeaderCollapse = () => {
    setIsHeaderCollapsed(!isHeaderCollapsed);
  };
  const navigate = useNavigate();
  const location = useLocation()

  const handleCardClick = (project) => {
    navigate(`/${params?.label}/project/${project?.id}`);
  };

  useEffect(() => {
    fetchProjectsSectorWise({ perPage: 30 })
  }, []);

  const handleChangeRowsPerPage = async (event) => {
    setProjectData([]);
    const perPage = parseInt(event.target.value);
    setRowsPerPage(perPage);
    setPage(0);
    await fetchProjectsSectorWise({ page: 1, perPage: perPage });
  };

  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await fetchProjectsSectorWise({
      page: newPage + 1,
      perPage: rowsPerPage,
    });
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleLogoResize = () => {
      setIsLogoMobile(window.innerWidth <= 767);
    };
    handleLogoResize();

    window.addEventListener("resize", handleLogoResize);

    return () => window.removeEventListener("resize", handleLogoResize);
  }, []);

  const fetchProjectsSectorWise = async (paginated = '') => {
    try {
      setIsLoading(true);
      const response = await getVisitorProjectsSectorWise({
        label: fetchSector(params?.label),
      }, {
        perPage: rowsPerPage,
        ...paginated
      })

      if (response.statusCode === 200) {
        setProjectData(response?.data?.data?.data)
        setIsLoading(false);
        setPaginationObject(response.data.data.meta);
      } else {
        toast.error(response.data.error);
        setPaginationObject(response.data.data.meta);
        setProjectData([])
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.message);
    }
  }

  const homePage = () => {
    navigate('/login')
  }

  return (
    <React.Fragment>
      <header id="page-topbar page_header">
        <div className="layout-width">
          <div className="navbar-header flex-wrap ps-2">
            {isMobile ? (
              <div>
                <img alt="visitor-small-logo" style={{ height: '60px', width: '100%', cursor: 'pointer' }} src={VisitorSmallLogo} onClick={homePage} />
              </div>
            ) :
              (
                <div>
                  <img alt='visitor-logo' src={VisitorLogo} style={{ cursor: 'pointer' }} onClick={homePage} />
                </div>
              )}
            {isLogoMobile ? (
              <div className="d-flex justify-content-end">
                <img alt='visitor-small-logo' style={{ height: '50px', width: '100%', cursor: 'pointer' }} src={VisitorSmallKacstLogo} onClick={homePage} />
              </div>
            ) :
              (
                <div className="d-flex justify-content-end">
                  <img alt='visitor-logo' src={VisitorKacstLogo} style={{ cursor: 'pointer' }} onClick={homePage} />
                </div>
              )}
          </div>
        </div>
      </header>
      <div className="page_content_header position-relative">
        <Container fluid>
          <div className="visitor_heading">
            <h4>{fetchSector(params?.label)}</h4>
          </div>
          {/* <div className="d-flex flex-wrap justify-content-between industry_card_wrap mt-3">
           <div className="industry_card_holder">
               <Card>
                   <CardBody>
                    <img src={EnergyImg} width='100%' />
                    <p className="mb-0 text-center mt-3">Smart Compress</p>
                    </CardBody>
                </Card>
            </div>
            <div className="industry_card_holder">
               <Card>
                   <CardBody>
                    <img src={EnergyIndustryImg} width='100%' />
                    <p className="mb-0 text-center mt-3">SMARTEX</p>
                    </CardBody>
                </Card>
            </div>
            <div className="industry_card_holder">
               <Card>
                   <CardBody>
                    <img src={GreenEnergyImg} width='100%' />
                    <p className="mb-0 text-center mt-3">Sustainable Exploitation</p>
                    </CardBody>
                </Card>
            </div>
            <div className="industry_card_holder">
               <Card>
                   <CardBody>
                    <img src={HPCEnergyImg} width='100%' />
                    <p className="mb-0 text-center mt-3">HPC Sky</p>
                    </CardBody>
                </Card>
            </div>
            <div className="industry_card_holder">
               <Card>
                   <CardBody>
                    <img src={SolarEnergyImg} width='100%' />
                    <p className="mb-0 text-center mt-3">Projects and Stratiges</p>
                    </CardBody>
                </Card>
            </div>
            <div className="industry_card_holder">
               <Card>
                   <CardBody>
                    <img src={HolisticEnergyImg} width='100%' />
                    <p className="mb-0 text-center mt-3">Holistic
                    Solutions</p>
                    </CardBody>
                </Card>
            </div>
      </div> */}
          {/* <div className="d-flex flex-wrap justify-content-between industry_card_wrap mt-3"> */}
          <Grid container spacing={2}>
            {projectData?.length > 0 && projectData.map((project, index) => (
              <Grid item xs={12} sm={12} md={6} lg={2} key={index}>
                <div className="industry_card_holder">
                  <Card onClick={() => handleCardClick(project)}>
                    <CardBody>
                      {project?.logo?.name && ['jpg', 'JPEG', 'jpeg', 'png', 'gif', 'bmp'].includes(project?.logo?.name?.split('.').pop().toString()) ? (
                        <img src={getUrl(project?.logo?.storageLink)} className="industry_card_holder_img" width="100%" alt={project?.logo?.name} />
                      ) : (
                        <img src={projectNoLog} width="100%" className="industry_card_holder_img" alt={project.name} />
                      )}

                      <p className="mb-0 text-center mt-3">
                        {project?.name?.length > 30 ? (
                          <Tooltip title={project.name}>
                            {project?.name?.slice(0, 30)}...
                          </Tooltip>
                        ) : project?.name}</p>
                    </CardBody>
                  </Card>
                </div>
              </Grid>
            ))}

          </Grid>
          <div className="ongoingProjPagination d-flex justify-content-end mt-3 newRoundedPagination">
            <PaginationComponent
              paginationObject={paginationObject}
              page={page}
              handleChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
          {/* {cardData.map((card, index) => (
        <div key={`second-row-${index}`} className="industry_card_holder">
          <Card>
            <CardBody>
              <img src={card.img} width="100%" alt={card.title} />
              <p className="mb-0 text-center mt-3">{card.title}</p>
            </CardBody>
          </Card>
        </div>
      ))}
       {cardData.map((card, index) => (
        <div key={`second-row-${index}`} className="industry_card_holder">
          <Card>
            <CardBody>
              <img src={card.img} width="100%" alt={card.title} />
              <p className="mb-0 text-center mt-3">{card.title}</p>
            </CardBody>
          </Card>
        </div>
      ))} */}
          {/* </div> */}
        </Container>
      </div>
    </React.Fragment>
  )
}
export default EnergyIndustry;